/**
 * WebhookFailureDetailPage — standalone, directly-addressable detail view for
 * a single webhook failure (#1390, converged in #1417).
 *
 * The inbox (`/webhooks/failures`) opens a Sheet drawer on row click,
 * which is not shareable. This route (`/webhooks/failures/:id`) renders
 * the SAME framework detail panel behind a page frame so an operator can
 * deep-link a failure. Both surfaces are now `ResourceDetailPage` /
 * `ResourcePage` over the one `webhookFailureResource`: the generic detail grid
 * shows provider/topic/error-kind/received-at, the `diagnosis` tab shows the
 * error head + raw payload, and the resolve/replay/delete footer is the resource's
 * `detail.actions` (a successful delete/resolve `afterAction: 'close'`s, which
 * on a standalone page navigates back to the list).
 */
import { ResourceDetailPage } from '@resource-kit/ui/react';
import { useWebhookFailureResource } from './webhookFailureResource';

export default function WebhookFailureDetailPage() {
  const resource = useWebhookFailureResource();
  return <ResourceDetailPage bundle={resource} />;
}
